(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-auteurs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.index-auteurs__filtre').forEach(function (btn) {
  btn.addEventListener('click', function () {
    document.querySelectorAll('.index-auteurs__filtre').forEach(function (b) {
      b.classList.toggle('est-actif', b === btn);
    });
    var maison = btn.dataset.maison;
    document.querySelectorAll('.index-auteurs__auteur').forEach(function (li) {
      var ok = maison === 'tous' || (li.dataset.maisons || '').split(' ').indexOf(maison) !== -1;
      li.classList.toggle('est-masque', !ok);
    });
    document.querySelectorAll('.index-auteurs__groupe').forEach(function (g) {
      var visibles = g.querySelectorAll('.index-auteurs__auteur:not(.est-masque)').length;
      g.classList.toggle('est-masque', visibles === 0);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
